import {IValidator} from "../interface";

const email = (data: IValidator) => {
    const {value, t} = data;

    if(value && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value as string)) {
        return Promise.reject(t("formError:email"));
    }

    return Promise.resolve()
}

export default email
